module.exports = __webpack_public_path__ + "static/media/money-check-edit-alt.76014cce.svg";